import { RegularExpressions } from "../../../../../assets/regularExpressionAssets";
import { enumSocialMediaPostType } from "../../../../enums";
import { ISocialMediaPostDisplaySpecs } from "../ISocialMediaPostDisplaySpecs";

/**
 * @function deriveDisplaySpecsForXOrTwitter Derives the specs needed to display an XOrTwitter Social Media Post from a raw reference
 * @param socialMediaPostRawReference The raw reference associated with the Social Media Post (eg, could be a URL or could be an <iframe>)
 */
export function deriveDisplaySpecsForXOrTwitter(socialMediaPostRawReference: string): ISocialMediaPostDisplaySpecs {

  // set default displaySpecs values for XOrTwitter
  let displaySpecs: ISocialMediaPostDisplaySpecs = { socialMediaPostType: enumSocialMediaPostType.Undefined, url: '', width: '100%', height: '100%' };;

  // execute the regular expression against the url to determine if the socialMediaPostRawReference represents a standard XOrTwitter Post EmbedUrl
  const matchEmbedUrl: RegExpExecArray | null = RegularExpressions.XOrTwitterPostEmbedUrl.exec(socialMediaPostRawReference);

  // if a match was made for a simple embed url...
  if (matchEmbedUrl && matchEmbedUrl.groups && matchEmbedUrl.groups.embedUrl) {
    // set the specs for displaying the post
    displaySpecs = { socialMediaPostType: enumSocialMediaPostType.XOrTwitter, url: matchEmbedUrl.groups.embedUrl, width: '100%', height: '100%' };
  } else {
    // execute the regular expression against the url to determine if the url represents an X post with a Twitter reference source
    const matchIFrameWithFullSpecs: RegExpExecArray | null = RegularExpressions.XPostWithTwitterRefSrc.exec(socialMediaPostRawReference);

    // if a match was made for an <iframe>...
    if (matchIFrameWithFullSpecs && matchIFrameWithFullSpecs.groups) {
      // set the Social Media Post Type
      displaySpecs.socialMediaPostType = enumSocialMediaPostType.TruthSocial;

      // if the embedUrl is found...
      if (matchIFrameWithFullSpecs.groups.embedUrl) {
        displaySpecs.url = matchIFrameWithFullSpecs.groups.embedUrl;
      }
    }
  }

  return displaySpecs;
}
